export const SEEKA_TRACKING_TYPE = 'Seeka';

type TrackingBeaconRaw = {
  resource_uri: string;
  id: string;
  tracking_type: string;
  event_id: string | null;
  user_id: string | null;
  organizer_id: string | null;
  pixel_id: string;
  public_key?: string;
  org_id?: string;
  triggers: Record<string, string>;
};

export type TrackingBeaconsResponse = {
  tracking_beacons?: TrackingBeaconRaw[];
};

export type TrackingBeacon = {
  pixelId: string;
  id: string;
  events: Record<string, string>;
};

// Seeka beacons carry three credentials (org / public key / instance) instead
// of a single pixelId. The BE reuses `pixel_id` as the per-instance scope and
// adds `org_id` + `public_key` for the org-level credentials.
export type SeekaTrackingBeacon = {
  orgId: string;
  publicKey: string;
  instanceId: string;
  id: string;
  events: Record<string, string>;
};

export type TrackingBeacons = Record<string, Array<TrackingBeacon | SeekaTrackingBeacon>>;

const toSeekaBeacon = (beacon: TrackingBeaconRaw): SeekaTrackingBeacon => ({
  orgId: beacon.org_id ?? '',
  publicKey: beacon.public_key ?? '',
  instanceId: beacon.pixel_id,
  id: beacon.id,
  events: beacon.triggers,
});

const toGenericBeacon = (beacon: TrackingBeaconRaw): TrackingBeacon => ({
  pixelId: beacon.pixel_id,
  id: beacon.id,
  events: beacon.triggers,
});

export const transformTrackingBeacons = (response: TrackingBeaconsResponse | undefined): TrackingBeacons | null => {
  if (!response?.tracking_beacons?.length) {
    return null;
  }

  const trackingBeacons: TrackingBeacons = {};

  response.tracking_beacons.forEach((beacon) => {
    const transformed = beacon.tracking_type === SEEKA_TRACKING_TYPE ? toSeekaBeacon(beacon) : toGenericBeacon(beacon);
    trackingBeacons[beacon.tracking_type] = [...(trackingBeacons[beacon.tracking_type] ?? []), transformed];
  });

  return trackingBeacons;
};
